/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { ReactComponent as Icon } from "./assets/circle-outline-small-question.svg";
import { colors, timings } from "../../theme";

const ToolTipButton = props => (
    <button
        {...props}
        css={css`
            background: none;
            color: inherit;
            border: none;
            padding: 0;
            font: inherit;
            cursor: pointer;
            outline: inherit;
        `}
    >
        <Icon
            height={30}
            width={30}
            css={css`
                fill: ${colors.neutral4};
                &:hover {
                    fill: ${colors.info4};
                }
                transition: ${timings.medium};
                vertical-align: bottom;
                margin-bottom: 2px;
            `}
        />
    </button>
);

export default ToolTipButton;
